import { CKLayoutGrid } from 'clearkit';

import { WhenProspector } from '../policies/WhenProspector';
import { ContactSales } from './CallsToAction/ContactSales';
import { FetchErrorRetry } from './CallsToAction/FetchErrorRetry';
import { Listing } from './Listing';
import { Loading } from './Loading';
import { Onboarding } from './Onboarding';
import { SidebarLists } from './Sidebar/SidebarLists';
import { SidebarNewList } from './Sidebar/SidebarNewList';
import { useProspector } from './useProspector';
import { ProspectorProvider } from './useProspector/Provider';

export function ProspectorPage() {
  const hasLists = false;

  return (
    <WhenProspector cta={<ContactSales />}>
      <ProspectorProvider>
        <CKLayoutGrid className="w-full" gap="0" gridTemplateColumns="auto 1fr">
          {hasLists ? <SidebarLists /> : <SidebarNewList />}
          <Prospector />
        </CKLayoutGrid>
      </ProspectorProvider>
    </WhenProspector>
  );
}

function Prospector() {
  const [state] = useProspector();

  if (state.value === 'loading') {
    return <Loading />;
  } else if (state.value === 'error') {
    return <FetchErrorRetry />;
  } else if (state.value === 'onboarding') {
    return <Onboarding />;
  }

  return <Listing />;
}
